import React, { useEffect } from 'react';

const SORO_SCRIPT_SRC = 'https://app.trysoro.com/api/embed/b334acb7-3cf9-466a-811e-e2d4c1601884';

const BlogSection = () => {
  useEffect(() => {
    if (document.querySelector(`script[src="${SORO_SCRIPT_SRC}"]`)) return;
    const script = document.createElement('script');
    script.src = SORO_SCRIPT_SRC;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return (
    <section id="blog" data-testid="blog-section" className="py-16 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto has-[.soro-embed:empty]:hidden">
      <h2 className="text-lg font-bold text-amber-400 uppercase tracking-widest mb-6">From Our Blog</h2>
      <div className="bg-white rounded-lg p-4">
        <div id="soro-blog" className="soro-embed"></div>
      </div>
    </section>
  );
};

export default BlogSection;
